import React from 'react';
import ConfidenceIndicator from './ConfidenceIndicator';
interface PositionCardProps {
  position: string;
  count: number;
  percentage: number;
  stakeholders: string[];
  compromiseOpportunity: boolean;
  confidence: number;
}
const PositionCard: React.FC<PositionCardProps> = ({
  position,
  count,
  percentage,
  stakeholders,
  compromiseOpportunity,
  confidence
}) => {
  return <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-78">
      <div className="p-5" data-id="element-79">
        <div className="flex justify-between items-start" data-id="element-80">
          <div data-id="element-81">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-82">{position}</h3>
            <p className="text-sm text-gray-500 mt-1" data-id="element-83">
              {count} submissions ({percentage}%)
            </p>
          </div>
          {compromiseOpportunity && <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-84">
              Compromise Opportunity
            </span>}
        </div>
        <div className="mt-3" data-id="element-85">
          <p className="text-sm font-medium text-gray-700" data-id="element-86">Key stakeholders:</p>
          <div className="mt-1 flex flex-wrap gap-1" data-id="element-87">
            {stakeholders.map((stakeholder, index) => <span key={index} className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-88">
                {stakeholder}
              </span>)}
          </div>
        </div>
        <div className="mt-4 flex justify-between items-center" data-id="element-89">
          <ConfidenceIndicator score={confidence} data-id="element-90" />
          <button className="text-sm text-blue-600 hover:text-blue-500 font-medium" data-id="element-91">
            View details
          </button>
        </div>
      </div>
    </div>;
};
export default PositionCard;